import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared.module';
import { SidenavComponent } from './pages/sidenav.component';


@NgModule({
  declarations: [
    SidenavComponent
  ],
  exports: [
    SidenavComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class SidenavModule { }
